import { format, isToday, isYesterday } from 'date-fns';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const JUST_NOW_MS = 45 * SECOND;

/**
 * Compact relative time as shown on the reference popup: "now", "2m ago",
 * "10m ago", then clock time, then a date. date-fns is only reached for the
 * rare older rows, so the hot path allocates nothing.
 */
export function relativeTime(at: number, now: number = Date.now()): string {
  const delta = now - at;
  if (delta < JUST_NOW_MS) return 'now';
  // Never "0m ago": between 45 seconds and a minute it is a minute, near enough.
  if (delta < HOUR) return `${Math.max(1, Math.floor(delta / MINUTE))}m ago`;

  const date = new Date(at);
  if (isToday(date)) return format(date, 'h:mm a');
  if (isYesterday(date)) return `Yesterday ${format(date, 'h:mm a')}`;
  return format(date, 'd MMM');
}

/** Long form for tooltips and `<time dateTime>` titles. */
export function absoluteTime(at: number): string {
  return format(new Date(at), "EEEE d MMM 'at' h:mm a");
}

export function isoTime(at: number): string {
  return new Date(at).toISOString();
}
